//常用公共类工具函数等api
export default {
  install: async function(Vue, options) {
    Vue.prototype.Common = {
      //判断是否为移动端，还是PC端
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag) return true;
        return false;
      },
      //判断是否为移动端，还是PC端
      getDetect() {
        let u = navigator.userAgent;
        var iswindows = u.indexOf("Windows", 0) != -1 ? 1 : 0;
        var ismac =
          navigator.platform == "Mac68K" ||
          navigator.platform == "MacPPC" ||
          navigator.platform == "Macintosh" ||
          navigator.platform == "MacIntel";
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (iswindows) {
          return "window";
        } else if (ismac) {
          return "mac";
        } else if (isAndroid) {
          return "android";
        } else if (isiOS) {
          return "ios";
        }
        return "";
      },
      //日期格式化
      dateFormatter(daterc, fmt) {
        var dat = new Date(daterc);
        var str = fmt;
        if (str == null) {
          str = "yyyy-MM-dd";
        }
        var Week = ["日", "一", "二", "三", "四", "五", "六"];
        str = str.toString().replace(/yyyy|YYYY/, dat.getFullYear());
        str = str
          .toString()
          .replace(
            /yy|YY/,
            dat.getFullYear() % 100 > 9
              ? (dat.getFullYear() % 100).toString()
              : "0" + (dat.getFullYear() % 100)
          );
        str = str
          .toString()
          .replace(
            /MM/,
            dat.getMonth() + 1 > 9
              ? (dat.getMonth() + 1).toString()
              : "0" + (dat.getMonth() + 1)
          );
        str = str.toString().replace(/M/g, dat.getMonth() + 1);
        str = str.toString().replace(/w|W/g, Week[dat.getDay()]);
        str = str
          .toString()
          .replace(
            /dd|DD/,
            dat.getDate() > 9 ? dat.getDate().toString() : "0" + dat.getDate()
          );
        str = str.toString().replace(/d|D/g, dat.getDate());
        str = str
          .toString()
          .replace(
            /hh|HH/,
            dat.getHours() > 9
              ? dat.getHours().toString()
              : "0" + dat.getHours()
          );
        str = str.toString().replace(/h|H/g, dat.getHours());
        str = str
          .toString()
          .replace(
            /mm/,
            dat.getMinutes() > 9
              ? dat.getMinutes().toString()
              : "0" + dat.getMinutes()
          );
        str = str.toString().replace(/m/g, dat.getMinutes());
        str = str
          .toString()
          .replace(
            /ss|SS/,
            dat.getSeconds() > 9
              ? dat.getSeconds().toString()
              : "0" + dat.getSeconds()
          );
        str = str.toString().replace(/s|S/g, dat.getSeconds());
        return str;
      },
      /*
            获取指定的URL参数值
            URL:http://www.blogjava.net/blog?name=bainian
            参数：paramName URL参数
            调用方法:getParam("name")
            返回值:bainian
            */
      //取url中参数值
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return false;
      },
      /*用户校验*/
      //校验用户名
      checkUserName(value) {
        if (value == "") {
          return false;
        }
        var isPhone = /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
          value
        );
        var isEMail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(
          value
        );
        var isIdcode = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/.test(
          value
        );
        if (!isPhone && !isEMail && !isIdcode) {
          return false;
        }

        return true;
      },
      //校验密码
      checkPassword(pass, pattern = "") {
        if (pattern != "") {
          var patternReg = new RegExp(pattern);
          return patternReg.test(pass);
        } else if (pass == "") {
          return false;
        }
        return true;
      },
      //校验确认密码
      checkEnterPassword(pass, checkPass) {
        return pass == checkPass;
      },
      //校验验证码
      checkCaptcha(value) {
        if (value == "" || value.length < 4) {
          return false;
        }
        return true;
      },
      //判断是否为整数数字
      isInt(number) {
        var numReg = /^[0-9]*$/;
        var numRe = new RegExp(numReg);
        if (!numRe.test(number)) {
          return false;
        }
        return true;
      },
      //判断是否为数字(含小数点)
      isNumber(number) {
        var numRe = new RegExp("^[-\\+]?([0-9]+\\.?)?[0-9]+$");
        if (!numRe.test(number)) {
          return false;
        }
        return true;
      },
      //获取文件扩展名
      getFileExtension(filename) {
        return filename.split(".").pop();
      },
      isURL(url) {
        if (url == "") return false;
        var strRegex =
          "^((https|http)://)?" +
          "(((([0-9]|1[0-9]{2}|[1-9][0-9]|2[0-4][0-9]|25[0-5])[.]{1}){3}([0-9]|1[0-9]{2}|[1-9][0-9]|2[0-4][0-9]|25[0-5]))" + // IP>形式的URL- 199.194.52.184
          "|" +
          "([0-9a-zA-Z\u4E00-\u9FA5\uF900-\uFA2D-]+[.]{1})+[a-zA-Z-]+)" + // DOMAIN（域名）形式的URL
          "(:[0-9]{1,4})?" + // 端口- :80
          "((/?)|(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?){1}";
        var re = new RegExp(strRegex);
        // console.log(re.test(url));
        return re.test(url);
      },
      isDate(dateString) {
        var date = new Date(dateString);
        //console.log(date)
        if (date == "Invalid Date") {
          return false;
        }
        return true;
      },
      isNull(str) {
        if (str == "" || str == undefined || str == null) {
          return true;
        }
        return false;
      },
      convertChars(s){
        //var str = "这是一个包含&ldquo;引用&rdquo;的句子。";
        s = s.replace(/&ldquo;/g, '“');
        s = s.replace(/&rdquo;/g, '”');
        s = s.replace(/&nbsp;/g, ' ');
        return s
      },
    };
  },
};
